import React from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";

export const COMPANY_API_KEY_ACTION = {
  REVOKE: "revoke",
  REACTIVATE: "reactivate",
};

function CompanyApiKeyActionModal({action, row, loading, onConfirm, onHide}) {
  const isRevoke = action === COMPANY_API_KEY_ACTION.REVOKE;
  return (
    <Modal show={!!row} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isRevoke ? "Revoke API Key" : "Reactivate API Key"}</Modal.Title>
      </Modal.Header>
      {row && <Modal.Body>
        <p>
          {isRevoke
            ? "Revoke this API key? Clients using it will be rejected right away (401)."
            : "Reactivate this API key? It will be active again, and its expiry date is cleared if it has expired."}
        </p>
        <div><b>Reseller:</b> {row.resellerName}</div>
        <div><b>Company:</b> {row.companyName}</div>
        <div><b>API Key:</b> {row.apiKey}</div>
        {isRevoke && row.isDefaultMigrated && <p className="text-warning mt-3 mb-0">
          This key was migrated from the reseller token. The reseller token itself still works
          through the legacy flow, so revoking this key does not block it.
        </p>}
      </Modal.Body>}
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>Cancel</Button>
        <Button variant={isRevoke ? "danger" : "success"} onClick={onConfirm} disabled={loading}>
          {loading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2"/>}
          {isRevoke ? "Revoke" : "Reactivate"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

CompanyApiKeyActionModal.propTypes = {};
CompanyApiKeyActionModal.defaultProps = {};

export default CompanyApiKeyActionModal;
